/**
 * global runtime constants for the plugin
 */
export var Const = {
    ////////////////////////// globals ////////////////////////////
    STORE_MODULE_NAME: "vue-provider-cache",
    REF: 'vpc',
    /**
     * router config for the remote
     * blockmaze-price-feed-microservice host
     */
    WS_PRICE_FEED_DOMAIN: {
        // HOST: 'https://bfeedzulu.capitalwallet.com',        //for dev
        // HOST: 'https://devpricefeed.capitalwallet.com',   // for live
        HOST: process.env.webSocket,
        EP_API_SEARCH_BY: '/api/ws-price-feed/search-by',
        EP_API_CONFIG: '/api/ws-price-feed/config'
    },
    ////////////////////////// actions ////////////////////////////
    // load global config 
    RUN_REGISTER_PROVIDERS: this.STORE_MODULE_NAME + '/' + this.REF + '/RUN_REGISTER_PROVIDERS',
    // run heartbeat for s single cachetag 
    RUN_HERARTBEAT: this.STORE_MODULE_NAME + '/' + this.REF + '/RUN_HERARTBEAT',
    //////////////////// mutations //////////////////////////////
    // start and register providers
    SET_REGISTER_PROVIDERS: this.STORE_MODULE_NAME + '/' + this.REF + '/SET_REGISTER_PROVIDERS',
    // update heartbeat for single provider
    SET_HEARTBEAT: this.STORE_MODULE_NAME + '/' + this.REF + '/SET_HEARTBEAT',
    //////////////////// getters //////////////////////////////
    // get heartbeats from all providers
    GET_HEARTBEATS: this.STORE_MODULE_NAME + '/' + this.REF + '/GET_HEARTBEATS',
    // get all providers
    GET_PROVIDERS: this.STORE_MODULE_NAME + '/' + this.REF + '/GET_PROVIDERS'
};
export var ConstCache = {
    ////////////////////////// globals ////////////////////////////
    STORE_MODULE_NAME: "vue-provider-cache",
    REF: 'vpc',
    /**
     * router config for the remote
     * blockmaze-price-feed-microservice host
     */
    WS_PRICE_FEED_DOMAIN: {
        // HOST: 'https://devpricefeed.capitalwallet.com:2087',
        // HOST: 'https://devpricefeed.capitalwallet.com:2096',
        HOST: process.env.webSocket,
        // HOST: 'https://dev.finvasia.com:5000',
        EP_API_SEARCH_BY: '/api/ws-price-feed/search-by',
        EP_API_CONFIG: '/api/ws-price-feed/config'
    },
    ////////////////////////// actions ////////////////////////////
    // load global config 
    RUN_REGISTER_PROVIDERS: this.STORE_MODULE_NAME + '/' + this.REF + '/RUN_REGISTER_PROVIDERS',
    // run heartbeat for s single cachetag 
    RUN_HERARTBEAT: this.STORE_MODULE_NAME + '/' + this.REF + '/RUN_HERARTBEAT',
    //////////////////// mutations //////////////////////////////
    // start and register providers
    SET_REGISTER_PROVIDERS: this.STORE_MODULE_NAME + '/' + this.REF + '/SET_REGISTER_PROVIDERS',
    // update heartbeat for single provider
    SET_HEARTBEAT: this.STORE_MODULE_NAME + '/' + this.REF + '/SET_HEARTBEAT',
    //////////////////// getters //////////////////////////////
    // get heartbeats from all providers
    GET_HEARTBEATS: this.STORE_MODULE_NAME + '/' + this.REF + '/GET_HEARTBEATS',
    // get all providers
    GET_PROVIDERS: this.STORE_MODULE_NAME + '/' + this.REF + '/GET_PROVIDERS'
};



//////////////////
// WEBPACK FOOTER
// ./src/plugins/vue-provider-cache/const.mod.ts
// module id = 3I5z
// module chunks = 1